import React from "react";
import { Link } from "react-router-dom";

const Insight = (props) => {
  const ourInsight = props.dataOurInsight.rows || "";
  const title = props.dataOurInsight.head || "";
  const baseUrl = props.url || "";
  const homeUrl=props.homeurl || "";


  return (
    <div className="container">
        <h2 className="text-center mb-4 universal-header">{title}</h2>
      <div className="insight-container">
        {ourInsight.map((insight, index) => (
          <div className="insight-card" key={index}>
            <div
              className="insight-card-background"
              style={{ backgroundImage: `url(${baseUrl+insight.image})` }}
            ></div>
            <div className="insight-card-content">
              <h3 className="card-title">{insight.title}</h3>
              <h4 className="card-category">{insight.description}</h4>
            </div>
            <div className="insight-card-hover">
              <p className="hover-description">{insight.hover_description}</p>
              {insight.button_name!==null ?<Link to={homeUrl+insight.button_link}>{insight.button_name}</Link>: null}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Insight;
